import { ITransaction } from "interfaces/entities/transaction";

import { IEntityCollectionState } from "../reducer";

export interface IWithTransactionsState {
  entities: {
    transactions: IEntityCollectionState<ITransaction>;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectTransactions(state: IWithTransactionsState) {
  return state.entities.transactions;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const selectTransactionSize = (state: IWithTransactionsState, transactionID: string) =>
  state.entities.transactions[transactionID].attachments.reduce((s, a) => s + a.size, 0);

export function getUploadTransaction(state: IWithTransactionsState, id: string): ITransaction | null {
  return selectTransactions(state)[id] || null;
}
